import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { PrivacyPolicyContent } from '@/features/auth/components/PrivacyPolicyContent';

type PrivacyPolicyDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

/**
 * Scrollable Privacy Notice modal for login and other auth flows (DEF-232).
 */
export function PrivacyPolicyDialog({
  open,
  onOpenChange,
}: PrivacyPolicyDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-h-[85vh] max-w-3xl overflow-y-auto bg-card text-foreground"
        aria-describedby="privacy-policy-description"
      >
        <DialogHeader>
          <DialogTitle className="text-foreground">Privacy Notice</DialogTitle>
          <DialogDescription
            id="privacy-policy-description"
            className="text-muted-foreground"
          >
            Stevenson Systems, Inc. — how we collect, use, and protect your
            information. Version 1.5, effective August 22, 2026.
          </DialogDescription>
        </DialogHeader>
        <PrivacyPolicyContent />
      </DialogContent>
    </Dialog>
  );
}
